import { render } from "./ScheduleTableRowMenu.vue?vue&type=template&id=72a81e87"
import script from "./ScheduleTableRowMenu.vue?vue&type=script&lang=ts"
export * from "./ScheduleTableRowMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script